import * as R from "ramda";

export default function PaymentInvoice(data) {
    let invoice = data || {};
    let recipientType = "";
    let issuerType = "";

    if (!R.isNil(invoice.partnerName) && R.isNil(invoice.etablissementName) && invoice.isDueToAssista) {
        recipientType = "Partner";
    } else if (!R.isNil(invoice.partnerName) && !R.isNil(invoice.etablissementName) && invoice.isDueToAssista) {
        recipientType = "Etablissement";
    }

    if (!R.isNil(invoice.partnerName) && R.isNil(invoice.etablissementName) && !invoice.isDueToAssista) {
        issuerType = "Partner";
    } else if (!R.isNil(invoice.partnerName) && !R.isNil(invoice.etablissementName) && !invoice.isDueToAssista) {
        issuerType = "Etablissement";
    }


    this.paid = invoice.paid;
    this.issuerId = invoice.issuerId;
    this.recipientName = invoice.recipientName;
    this.id = invoice.id;
    this.amount = invoice.amount;
    this.created = new Date(invoice.created);
    this.number = invoice.number;
    this.isDueToAssista = invoice.isDueToAssista;
    this.pdfUrl = invoice.pdfUrl;
    this.partnerName = invoice.partnerName;
    this.etablissementName = invoice.etablissementName;
    this.recipientType = recipientType;
    this.issuerType = issuerType;
    this.totalToPay = invoice.isDueToAssista ? 0 : invoice.amount;
    this.totalToBill = invoice.isDueToAssista ? invoice.amount : 0;
    this.status = invoice.status;


}